<div class="banner pageHeight" id="homeMob">
  <div class="banner-content">
    <h1 class="section-title text-uppercase m-0">
      <span class="mb-0 text-white d-flex align-item-start justify-content-between justify-content-md-start gap-2 gap-sm-3">
        {{ 'banner.banner_text_1' | translate }}

        <div class="social-icons d-flex align-items-start gap-2 ms-sm-4">
          <a href="https://x.com/pepenode_io" target="_blank"><img src="/assets/images/social-icons/twitter.svg"
              class="" alt="twitter" height="43" /></a>
          <a href="https://t.me/pepe_node" target="_blank" ><img src="/assets/images/social-icons/telegram.svg" class="" alt="telegram" height="43" /></a>
        </div>
      </span>
    </h1>
    <h2 class="sub-title text-primary text-uppercase"> {{ 'banner.banner_text_2' | translate }}</h2>


    <h3 class="section-desc mt-2" *ngIf="!isMobile" [innerHTML]="'banner.banner_desc' | translate">
    </h3>
    <div class="coin-wrap mb-3 mt-3 mt-lg-0">
      <div class="d-flex align-items-center justify-content-start pb-1">
        <img src="/assets/images/webp/buy-icon.webp" alt="buy-icon" class="buy-icon d-block" />
        <p class="h2-item">{{ 'banner.para_1' | translate }}</p>
      </div>
  
      <div class="d-flex align-items-center justify-content-start pb-1">
        <img src="/assets/images/webp/upgrade-icon.webp" alt="buy-icon" class="buy-icon d-block" />
        <p class="h2-item">{{ 'banner.para_2' | translate }}</p>
      </div>
   
      <div class="d-flex align-items-center justify-content-start pb-1">
        <img src="/assets/images/webp/meme-icon.webp" alt="buy-icon" class="buy-icon d-block" />
        <p class="h2-item">{{ 'banner.para_3' | translate }}</p>
      </div>
    </div>
  </div>
  <!-----------Desktop ------- -->
  <div class="banner-bottom" *ngIf="!isMobile">
    <div class="reward-info mb-lg-3 position-relative">
      <p class="fix-apy mb-0">{{ stakeData }}%</p>
      <p class="staking-reward mb-0 text-center">{{ 'banner.staking_rewards' | translate }}</p>
      <!-- <img src="/assets/images/svg-icons/icon-info.svg" alt="info-icon" class="info-icon cursor-pointer" /> -->
    </div>

    <div class="drop-shadow d-inline">
      <button (click)="showWidget()" class="btn btn-primary animation py-2 font-19 fw-semibold">{{ 'banner.buy_node' |
        translate }}</button>
    </div>

    <div class="tags mt-3">
      <p class="outline-btn h-item">{{ 'banner.banner_desc_bottom' | translate }}</p>
    </div>
  </div>

  <!-----------Mobile ------- -->
  <app-widget *ngIf="isMobile"></app-widget>
  <div class="banner-bottom overflow-hidden" *ngIf="isMobile">
    <div
      class="reward-info mb-lg-3 position-relative d-flex align-items-center justify-content-center w-100 mt-3 text-center">
      <p class="fix-apy mb-0 me-1">{{ stakeData }}%</p>
      <p class="staking-reward mb-0 text- mwx-60 text-start">{{ 'banner.staking_rewards' | translate }}</p>
      <!-- <img src="/assets/images/svg-icons/icon-info.svg" alt="info-icon" class="info-icon cursor-pointer" /> -->
    </div>
  </div>
 <!-----------Desktop & Mobile ------- -->
  <div class="video-wrap">
    <video class="video" width="100%" #videoPlayer autoplay muted playsInline loop>
      <source src="/assets/images/videos/banner.mp4" type="video/mp4" />
      Your browser does not support the video tag
    </video>
  </div>

  <!-----------Mobile ------- -->
  <h3 class="section-desc mt-2" *ngIf="isMobile" [innerHTML]="'banner.banner_desc' | translate"></h3>
  <a *ngIf="isMobile" href="https://app.coinsult.net/eth/0xd29191a6d2aae7c0e60f4722018832addf4b9831" target="_blank"
    class="d-flex justify-content-center align-items-center gap-3 my-3">
    <div class="fs-7">{{ "widget.trust_safety" | translate }}</div>
    <svg-icon src="/assets/images/svg-icons/coin_sult.svg"
      [svgStyle]="{ 'width.px': '92', 'height.px': '23' }"></svg-icon>
  </a>

   <!-----------Mobile ------- -->
  <app-notification-purchase *ngIf="isMobile"></app-notification-purchase>


   <!-----------Mobile ------- -->
  <div class="tags mt-3 mb-3" *ngIf="isMobile">
    <p class="outline-btn font-13 h-item">{{ 'banner.banner_desc_bottom' | translate }}</p>
  </div>
  <div class="topSection" *ngIf="isMobile">
    <p class="trustedBy">{{ 'misc.trusted_by' | translate }}</p>
    <svg-icon src="/assets/images/svg-icons/pattern-widget.svg"
      [svgStyle]="{ 'width.px': '360', 'height.px': '20' }"></svg-icon>
    <app-feature></app-feature>
  </div>
</div>